import { Component, inject, input, OnInit, signal } from '@angular/core';
import { HeadlineService } from '../../../headline/headline.service';
import { Product } from '@mwe/models';
import { ProductTariffCardTemplateComponent } from '../../tariff-card-template/product-tariff-card-template.component';
import { InfoboxComponent } from '../../../infobox/infobox.component';
import { ButtonLinkComponent } from '../../../buttons/button-link/button-link.component';
import { ProductDetailsLogic, ProfileService } from '@mwe/services';
import { FeatureToggleEnum } from '@mwe/constants';

@Component({
  selector: 'mwe-tariff-card-emobility',
  templateUrl: './tariff-card-emobility.component.html',
  imports: [ProductTariffCardTemplateComponent, InfoboxComponent, ButtonLinkComponent],
  providers: [HeadlineService],
})
export class TariffCardEmobilityComponent implements OnInit {
  private readonly profileService = inject(ProfileService);
  private readonly productDetailsLogic = inject(ProductDetailsLogic);
  protected readonly headlineService = inject(HeadlineService);

  readonly product = input.required<Product>();

  readonly isTariffChangeAvailable = signal<boolean>(false);

  ngOnInit(): void {
    this.isTariffChangeAvailable.set(this.profileService.isFeatureToggleEnabled(FeatureToggleEnum.CHARGING_CARD_TARIFF_CHANGE_ENABLED));
  }

  startTariffChange(): void {
    this.productDetailsLogic.changeEmobilityTariff(this.product());
  }
}
